import * as React from 'react';
import mediaQuery from '../helpers/mediaQuery';

function useMediaQuery(): { isSmall: boolean; isMedium: boolean; isLarge: boolean; isXLargeUp: boolean } {
  const [isSmall, setIsSmall] = React.useState(mediaQuery.isSmallOnly());
  const [isMedium, setIsMedium] = React.useState(mediaQuery.isMediumOnly());
  const [isLarge, setIsLarge] = React.useState(mediaQuery.isLargeOnly());
  const [isXLargeUp, setIsXLargeUp] = React.useState(mediaQuery.isXLargeUp());

  React.useEffect(() => {
    function onResize(): void {
      const isSmallAfterResize = mediaQuery.isSmallOnly();
      const isMediumAfterResize = mediaQuery.isMediumOnly();
      const isLargeAfterResize = mediaQuery.isLargeOnly();
      const isXLargeUpAfterResize = mediaQuery.isXLargeUp();

      /* istanbul ignore else */
      if (isSmall !== isSmallAfterResize) {
        setIsSmall(isSmallAfterResize);
      }

      /* istanbul ignore else */
      if (isMedium !== isMediumAfterResize) {
        setIsMedium(isMediumAfterResize);
      }

      /* istanbul ignore else */
      if (isLarge !== isLargeAfterResize) {
        setIsLarge(isLargeAfterResize);
      }

      /* istanbul ignore else */
      if (isXLargeUp !== isXLargeUpAfterResize) {
        setIsXLargeUp(isXLargeUpAfterResize);
      }
    }

    window.addEventListener('resize', onResize);
    return (): void => window.removeEventListener('resize', onResize);
  }, [isSmall, isMedium, isLarge, isXLargeUp]);

  return { isSmall, isMedium, isLarge, isXLargeUp };
}

export default useMediaQuery;
